import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// Alertify
import * as alertify from '../../../components/Alerts/lib/alertify';

// Api
import api from '../../../api/lib/getEverything.lib.api';
import listDepartmentsApi from '../../api/list.api.department';
import { updateUserApi } from '../../../api/endpoints';

// Components
import Departments from '../../components/Departments/Departments';
import FullScreenLoader from '../../../layout/components/FullScreenLoader/FullScreenLoader';

// Context
import { useAuth } from '../../../contexts';
import { useApp } from '../../../contexts';

const DepartmentsContainer = ({ children }) => {
  const { user } = useAuth();
  const { loading, departments, department, showDepartments, setLoading, setDepartments, setDepartment, setShowDepartments } = useApp();
  const [search, setSearch] = useState('');

  useEffect(() => {
    const init = () => {
      if (!user) return;
      setSearch('');
      getDepartments();
    };

    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const getDepartments = async () => {
    setLoading(true);
    const { data: departmentsList } = await api(listDepartmentsApi);
    const userDepartment =
      departmentsList.find(({ _id }) => _id === user.department) || null;
    setDepartments(departmentsList);
    setDepartment(userDepartment);
    setShowDepartments(!userDepartment);
    setLoading(false);
  };

  const selectDepartment = (dept) => async () => {
    if (loading) return;

    setLoading(true);

    try {
      await updateUserApi({ department: dept._id });
      setDepartment(dept);
      setShowDepartments(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      alertify.error('Napaka');
    }
  };

  const handleSearch = (value) => setSearch(value);

  const back = () => {
    if (loading || !department) return;
    setShowDepartments(false);
  };

  const filteredDepartments = () => {
    const searchTerm = search.toLowerCase();
    return !!searchTerm.trim().length
      ? departments.filter(({ name }) => name.toLowerCase().includes(searchTerm))
      : departments;
  };

  if (!user) return children;

  return loading ? (
    <FullScreenLoader />
  ) : showDepartments || !department ? (
    <Departments
      search={search}
      department={department}
      departments={filteredDepartments()}
      onBack={back}
      onDepartment={selectDepartment}
      onSearch={handleSearch}
    />
  ) : (
    children
  );
};

DepartmentsContainer.propTypes = {
  children: PropTypes.node,
};

export default DepartmentsContainer;
